export default {
	data() {
		return {
			//当前批次的id
			currentBatchId: '',
			//被勾选的学生数组
			students: [],
			//批次的每页要的数量
			batchLength: 15,
			//批次的偏移量
			batchOffset: 0,
			//批次总数量
			batchTotal: 0,
			//来搜索批次的备注
			batchNameSearch: '',
			//按照批次时间搜索
			selectTime: '',
			//把搜索的时间转化格式
			batchTime: '',
			//存储批次的数组
			batchs: [],
			//存储批次里面的学员数组
			students: [],
			//存储批次里面的课程的数组
			lessons: [],
			//课程统计的价格
			lessonStatisticsMoney: 0,
			//课程统计的学时
			lessonPeroid: 0,
			//测试
			test: [{
				name: '1'
			}, {
				name: '1'
			}],
			//控制开课按钮
			buttontype: false,
			// 节流
			click: 0,

		}
	},
	methods: {
		//获取已经勾选的学生数组
		handleStudentChange(val) {
			this.students = val;
		},
		//每页请求的条数发生变化时候
		handleSizeChangeBatch(length) {
			//改变每页请求的数目
			this.batchLength = length;
			this.getAllBatch();
		},
		//当前页数发生改变
		handleCurrentChangeBatch(page) {
			//把传来的当前页计算出偏移量
			this.batchOffset = (page - 1) * this.batchLength
			this.getAllBatch();
		},
		//获取所有批次
		getAllBatch() {
			//因为清除按钮会把时间默认清除到1970-01-01
			String(this.selectTime) == 'null' ? this.batchTime = '' : this.batchTime;
			//请求的data
			let data = {
				token: this.$store.state.authority_management,
				length: this.batchLength,
				offset: this.batchOffset,
				remarks: this.batchNameSearch,
				created_at: this.batchTime,
				shop_id: this.$store.state.store.id
			}
			this.$post('selected_batch/search', data).then(res => {
				// console.log(res.data);
				this.batchs = res.data.result.data;
				this.batchTotal = res.data.result.total;
			})
		},
		//设置改批次无效
		setBatchLoseEfficacy(obj) {
			let name = obj.remarks;
			let data = {
				token: this.$store.state.authority_management,
				state: '0',
				id: obj.id
			}
			this.$post('selected_batch/edit', data).then(res => {
				if (res.data.status == 'success') {
					this.$alert('设置批次：' + name + '为无效成功', '设置成功', {
						confirmButtonText: '确定',
					});
					//设置批次状态再次请求数据更新
					this.searchBatch();
				} else {
					this.$message({
						message: '设置无效失败',
						type: 'error'
					})
				}
			})
		},
		//按照条件搜索批次
		searchBatch() {
			//判断时间是否输入了
			if (this.selectTime != "" && String(this.selectTime) != "null") {
				// 搜索时间的转换
				var d = new Date(this.selectTime);
				let year = d.getFullYear(),
					month = d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1),
					day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
				let time = year + '-' + month + '-' + day;
				this.batchTime = time;
			}
			this.getAllBatch();

		},
		//获取开课信息
		getOpenClassInfo(obj) {
			// 点击开课信息，跳转到指定位置
			let a = document.createElement('a');
			a.setAttribute('href', '#link');
			a.setAttribute('id', 'js_a')
			// 防止重复添加
			if (document.getElementById('js_a')) {
				document.body.removeChild(document.getElementById('js_a'));
			}
			document.body.appendChild(a);
			a.click();

			console.log(obj)
			if (obj.state == 1) {
				this.buttontype = false
			} else {
				this.buttontype = true
			}
			console.log(this.buttontype)

			this.currentBatchId = obj.id;
			//置空一下课程总价格
			this.lessonStatisticsMoney = 0;
			this.lessonPeroid = 0;
			let data = {
				selected_batch_id: obj.id,
				token: this.$store.state.authority_management,
				offset: 0,
				length: 999
			}
			//获取开课的课程
			this.$post('selected/search_group_by_category', data).then(res => {
				this.lessons = res.data.result.data;

				// 计算总价和学时
				for (let val of this.lessons) {
					let period = 0; // 学时
					for (let product of val.product_category_mapping) {
						period += product.product_period * 1;
					}
					this.$set(val, 'period', period);

					// 套餐总价
					this.lessonStatisticsMoney += Number.parseFloat(val.price);
					// 套餐总学时
					this.lessonPeroid += period
				}
			});
			//获取开课的学员
			this.$post('selected/search_group_by_user', data).then(res => {
				this.students = res.data.result.data;

			});
		},
		//确定开课
		confirmOpenClass() {
			if (!this.click) {
				this.click = 1;
				let user_id_arr = [];
				let product_id = [];
				//求出课程id数组
				for (let val of this.lessons) {
					product_id.push(val.category_id);
				}
				//求出学员id数组
				for (let val of this.students) {
					user_id_arr.push(val.user_id);
				}
				let data = {
					token: this.$store.state.authority_management,
					user_ids: JSON.stringify(user_id_arr),
					category_ids: JSON.stringify(product_id),
					selected_batch_id: this.currentBatchId
				}
				let dataTwo = {
					token: this.$store.state.authority_management,
					state: '2',
					id: this.currentBatchId
				}
				//给学员开课
				this.$post('orders/batch_create', data).then(res => {

					if (res.data.status == 'success') {
						this.$alert('开课成功', '开课成功', {
							confirmButtonText: '确定',
						});

						//开课成功要把相应批次的状态改成已完成开课
						this.$post('selected_batch/edit', dataTwo);
					} else {
						this.$message({
							message: res.data.errorMsg,
							type: 'error'
						});
					}
				})

				setTimeout(() => {
					this.click = 0
				}, 3000)
			}
			return

		},
	},
	created() {
		this.getAllBatch();
	}
}
